export default __webpack_public_path__ + "static/media/Mail.80b8a34e.svg";